/**
 * @memberOf loavies.models.error
 * @constructor
 */
export class ApiError extends Error {
  /**
   * @param {string} [message]
   * @param {string} [messageTranslationKey]
   * @param {number} statusCode
   * @param {string} [details]
   */
  constructor ({
    message,
    messageTranslationKey,
    statusCode,
    details = '',
  }) {
    super(message)

    /** @type {string} */
    this.messageTranslationKey = messageTranslationKey

    /** @type {number} */
    this.statusCode = statusCode

    /** @type {string} */
    this.details = details
  }
}
